module.exports = __webpack_public_path__ + "static/img/h_25@2x.911354f1.png";